import Parse from "parse";

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useGame } from "../header/GameContext";
import { ANSWERS_DATA } from "./quizData";

function QuizeCheck({ answerData, onWrong }) {
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const { DB_TABLE, increaseMissionOnce } = useGame();

  const normalize = (str) => str.replace(/\s+/g, "").toLowerCase();

  // 페이지 이동('/answer'에 맞는 state) : 일반퀴즈
  const handleAnswerCorrect = (quiz) => {
    navigate(quiz.next.route, {
      state: {
        DateVal: quiz.next.DateVal,
        missionKey: answerData,
        titImgClass: quiz.next.titImgClass,
        counting: quiz.next.counting,
      },
    });
  };

  const handleSubmit = async () => {
    const quiz = ANSWERS_DATA[answerData];

    if (!quiz) {
      onWrong?.();
      return;
    }

    const isCorrect = (() => {
      const input = normalize(value);
      const answers = Array.isArray(quiz.answer) ? quiz.answer : [quiz.answer];
      return answers.some((ans) => normalize(ans) === input);
    })();

    // ❌ 오답 처리
    if (!isCorrect) {
      onWrong?.();

      try {
        const GameUser = Parse.Object.extend(DB_TABLE);
        const query = new Parse.Query(GameUser);
        const objectId = localStorage.getItem("gameUserId");
        const user = await query.get(objectId);

        const clearedStage = user.get("cleared_stage") || {};
        clearedStage[answerData] = false;
        user.set("cleared_stage", clearedStage);
        await user.save();
      } catch (error) {
        console.error("에러 코드:", error.code);
        console.error("에러 메시지:", error.message);
      }

      return;
    }

    // ✅ 정답 (다음 페이지 이동 + 클리어카운트증가)
    try {
      const GameUser = Parse.Object.extend(DB_TABLE);
      const query = new Parse.Query(GameUser);
      const objectId = localStorage.getItem("gameUserId");
      const user = await query.get(objectId);

      const clearedStage = user.get("cleared_stage") || {};
      clearedStage[answerData] = true; // 👈 DateVal → answerData로 통일
      user.set("cleared_stage", clearedStage);
      await user.save();

      handleAnswerCorrect(quiz);
      increaseMissionOnce(answerData);
    } catch (error) {
      console.error("에러 코드:", error.code);
      console.error("에러 메시지:", error.message);
    }
  };

  return (
    <div className="mt24 mb40">
      <input
        className="input01"
        placeholder="정답을 입력하세요."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
      />
      <button className="inputBtn02 mt16" onClick={handleSubmit}>
        입력 완료
      </button>
    </div>
  );
}

export default QuizeCheck;
